import React, { FC } from 'react';

const Skills: FC = () => (
    <>
        Skills coming soon...
    </>
);

export default Skills;